import store from "@/store";

class ShopeeMessage {

	static getInstance() {
	  if (!this.instance) {
	    this.instance = new ShopeeMessage();
	  }
	  return this.instance;
	}

	new_message(message) {
		if (message.sync_type && message.sync_type == 'SESSION_UPDATE') {
			store.commit("shopee/updateSession", message);
		} else {		
			store.commit("shopee/messageHanle", message);
			store.commit("shopee/updateMessage", message.message);
		}
	}

	session_list(message) {
		for (let i in message) {
			store.commit("shopee/setSessionData", message[i]);			
		}

	}

	invitation(message) {
		store.commit("shopee/invitationSession", message);
	}

	transfer(message) {
		console.log(message);
		store.commit("shopee/transferSession", message);
	} 

}

export default ShopeeMessage.getInstance();